import dayjs from 'dayjs'
export default function formatDate(input) {
  var date = dayjs(input)
  if (date.isValid()) {
    return date.format('MM/DD/YYYY')
  } else {
    return ''
  }
}
